<ng-template #documentModal>
    <div class="modal-inner pdf-viewer-container">
        <div class="pdf-modal-controls">
            <button class="left-control"
                    mat-icon-button
                    type="button"
                    (click)="onPrint()">
                <mat-icon aria-label="Zoom out">print</mat-icon>
            </button>

            <div class="buttons-center">
                <button mat-icon-button
                        type="button"
                        (click)="zoomOut()">
                    <mat-icon aria-label="Zoom out">zoom_out</mat-icon>
                </button>
                <span class="zoom-text">
                    {{ zoom * 100 | number }} %
                </span>
                <button mat-icon-button
                        type="button"
                        (click)="zoomIn()">
                    <mat-icon aria-label="Zoom in">zoom_in</mat-icon>
                </button>
            </div>

            <button class="left-control"
                    mat-icon-button
                    type="button"
                    (click)="closeDialog()">
                <mat-icon aria-label="Close">clear</mat-icon>
            </button>
        </div>

        <pdf-viewer [original-size]="true"
                    [fit-to-page]="true"
                    [show-all]="true"
                    [src]="source"
                    [zoom]="zoom">
        </pdf-viewer>
    </div>
</ng-template>
